import { PropsWithChildren } from 'react';
import styles from './CardHeader.module.css';

export const CardHeader = ({ children }: PropsWithChildren) => <div className={styles.cardHeader}>{children}</div>;
